export function isCommonCategoryFieldCheck(val) {
  return (
    val.name == "Bulk Extract" ||
    val.name == "Cartridge" ||
    val.name == "Live Plant" ||
    val.name == "Edibles & Drink" ||
    val.name == "Extract" ||
    val.name == "Topicals & Wellness" ||
    val.name == "Merchandise" ||
    val.name == "Plant Material" ||
    val.name == "Flower" ||
    val.name == "Prepack" ||
    val.name == "Preroll" ||
    val.name == "Pack To Order" ||
    val.name == "Seed" ||
    val.name == "Tincture"
  );
}
export function showPrerollTypeFieldCheck(val) {
  return val.name == "Preroll";
}
export function showGramPerPrerollCheck(val) {
  return val.name == "Preroll";
}
export function showGrowMediumFieldCheck(val) {
  return val.name == "Plant Material" || val.name == "Flower" || val.name == "Prepack" || val.name == "Live Plant" || val.name == "Pack To Order";
}
export function showStateOfMaterialsFieldCheck(val, type = null) {
  return val.name == "Plant Material" && type == "Biomass";
}
export function showTrimmingMethodsFieldCheck(val) {
  return val.name == "Plant Material" || val.name == "Flower" || val.name == "Prepack" || val.name == "Pack To Order";
}
export function showDryingMethodsFieldCheck(val) {
  return val.name == "Plant Material" || val.name == "Flower" || val.name == "Prepack" || val.name == "Pack To Order";
}
export function showStorageTypesFieldCheck(val) {
  return val.name == "Plant Material";
}
export function showContainerTypesFieldCheck(val) {
  return (
    val.name == "Plant Material" ||
    val.name == "Pack To Order" ||
    val.name == "Prepack" ||
    val.name == "Preroll" ||
    val.name == "Seed" ||
    // || val.name == 'Live Plant' Live Plant container types are handled by case and package size checks
    val.name == "Bulk Extract" ||
    val.name == "Extract"
  );
}
export function showDocumentsUploadFieldCheck(val) {
  return (
    val.name == "Plant Material" ||
    val.name == "Flower" ||
    val.name == "Prepack" ||
    val.name == "Preroll" ||
    val.name == "Bulk Extract" ||
    val.name == "Extract" ||
    val.name == "Cartridge" ||
    val.name == "Topicals & Wellness" ||
    val.name == "Edibles & Drink" ||
    val.name == "Pack To Order"
  );
}
export function showIngredientsFieldCheck(val) {
  return (
    val.name == "Plant Material" ||
    val.name == "Flower" ||
    val.name == "Prepack" ||
    val.name == "Preroll" ||
    val.name == "Bulk Extract" ||
    val.name == "Extract" ||
    val.name == "Cartridge" ||
    val.name == "Topicals & Wellness" ||
    val.name == "Edibles & Drink" ||
    val.name == "Pack To Order"
  );
}
export function showGrowEnvironmentFieldCheck(val) {
  return (
    val.name == "Plant Material" ||
    val.name == "Flower" ||
    val.name == "Prepack" ||
    val.name == "Preroll" ||
    val.name == "Seed" ||
    val.name == "Live Plant" ||
    val.name == "Pack To Order"
  );
}
export function showPackToOrderPricesCheck(val) {
  return val.name == "Pack To Order";
}
export function showPackagedUnitSizeFieldCheck(val) {
  return val.name == "Prepack";
}
export function showGovernmentAgengiesCheck(val, industry) {
  return industry == "hemp" && (val.name == "Seed" || val.name == "Live Plant");
}
export function showFeminizedCheck(val) {
  return val.name == "Seed";
}
export function showFloweringPeriodsCheck(val) {
  return val.name == "Seed" || val.name == "Live Plant";
}
export function showYieldsPerAcreOutdoorCheck(val) {
  return val.name == "Seed" || val.name == "Live Plant";
}
export function showCuringMethodCheck(val, type = null) {
  return (
    (val.name == "Plant Material" && type != "Biomass") ||
    (val.name == "Flower" && type != "Biomass") ||
    (val.name == "Prepack" && type != "Biomass") ||
    (val.name == "Pack To Order" && type != "Biomass")
  );
}
export function showPerSqFtIndoorCheck(val) {
  return val.name == "Seed" || val.name == "Live Plant";
}
export function showGerminationRateCheck(val) {
  return val.name == "Seed";
}
export function showHermMaleRateCheck(val, type = null) {
  return val.name == "Seed" || (val.name == "Live Plant" && (type == "Starts" || type == "Seedlings"));
}
export function showLineageCheck(val) {
  return val.name == "Seed" || val.name == "Live Plant";
}
export function showEnvironmentalIssuesFieldCheck(val) {
  return val.name == "Live Plant";
}
export function showTypesFieldCheck(val) {
  return (
    val.name == "Bulk Extract" ||
    val.name == "Extract" ||
    val.name == "Cartridge" ||
    val.name == "Edibles & Drink" ||
    val.name == "Tincture" ||
    val.name == "Topicals & Wellness" ||
    val.name == "Plant Material" ||
    val.name == "Flower" ||
    val.name == "Merchandise" ||
    val.name == "Live Plant" ||
    val.name == "Pack To Order" ||
    val.name == "Prepack"
  );
}
export function showExtractionMethodsFieldCheck(val) {
  return val.name == "Bulk Extract" || val.name == "Cartridge";
}
export function showProductFlavorsCheck(val) {
  return val.name == "Cartridge";
}
export function showProductAdditivesCheck(val) {
  return val.name == "Cartridge";
}
export function showUnitsSizeCheck(val) {
  return (
    val.name == "Cartridge" ||
    val.name == "Merchandise" ||
    val.name == "Edibles & Drink" ||
    val.name == "Tincture" ||
    val.name == "Extract" ||
    val.name == "Topicals & Wellness"
  );
}
export function showUnitOfMeasurementFieldCheck(val) {
  return (
    val.name != "Prepack" &&
    val.name != "Live Plant" &&
    val.name != "Preroll" &&
    val.name != "Merchandise" &&
    val.name != "Cartridge" &&
    val.name != "Edibles & Drink" &&
    val.name != "Tincture" &&
    val.name != "Extract" &&
    val.name != "Topicals & Wellness"
  );
}
export function showUnitSizeUnitOfMeasurementFieldCheck(val) {
  return (
    val.name == "Merchandise" ||
    val.name == "Cartridge" ||
    val.name == "Edibles & Drink" ||
    val.name == "Tincture" ||
    val.name == "Extract" ||
    val.name == "Topicals & Wellness"
  );
}
export function showPackageAndCaseOptions(val) {
  return (
    val.name == "Cartridge" ||
    val.name == "Preroll" ||
    val.name == "Live Plant" ||
    val.name == "Prepack" ||
    val.name == "Edibles & Drink" ||
    val.name == "Tincture" ||
    val.name == "Topicals & Wellness" ||
    val.name == "Merchandise" ||
    val.name == "Extract"
  );
}
export function showInfusionMethodFieldCheck(val, industry, type = null) {
  return (
    val.name == "Edibles & Drink" ||
    val.name == "Tincture" ||
    val.name == "Topicals & Wellness" ||
    (industry == "cannabis" && val.name == "Extract" && (type == "Isolate" || type == "Water Soluble" || type == "Distillate"))
  );
}
export function showForPetsFieldCheck(val) {
  return val.name == "Topicals & Wellness" || val.name == "Edibles & Drink" || val.name == "Tincture";
}
export function showPrePopulateFieldCheck(val) {
  return val.name != "Merchandise";
}
export function showCultivarFieldCheck(val, type = null) {
  return (
    val.name != "Merchandise" &&
    val.name != "Topicals & Wellness" &&
    !(val.name == "Tincture" && type == "Isolate") &&
    !(val.name == "Bulk Extract" && (type == "Isolate" || type == "Water Soluble")) &&
    !(val.name == "Extract" && (type == "Isolate" || type == "Water Soluble"))
  );
}
export function showCultivarTypeFieldCheck(val, type = null) {
  return (
    val.name != "Merchandise" &&
    val.name != "Topicals & Wellness" &&
    !(val.name == "Tincture" && type == "Isolate") &&
    !(val.name == "Bulk Extract" && (type == "Isolate" || type == "Water Soluble")) &&
    !(val.name == "Extract" && (type == "Isolate" || type == "Water Soluble"))
  );
}
export function showCrudeExtractTypeFieldCheck(type, category) {
  if (type === undefined || type.name === undefined) {
    return false;
  }
  return (category.name == "Extract" || category.name == "Bulk Extract") && type.name == "Crude";
}
export function showDistillateExtractTypeFieldCheck(type, category) {
  if (type === undefined || type.name === undefined) {
    return false;
  }
  return (category.name == "Extract" || category.name == "Bulk Extract") && type.name == "Distillate";
}
